import { useEffect, useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import MediaQuery from "react-responsive";
import Typography from "@mui/material/Typography";
import Desktop from "./components/desktop";
import Mobile from "./components/mobile";
import { getStatus } from "./services/getStatus";

function Entregas({ dados, deliverySelected, setDeliverySelected }) {
  const [open, setOpen] = useState();
  const [info, setInfo] = useState();

  useEffect(() => {
    if (deliverySelected) {
      getStatus(
        deliverySelected.numnota,
        deliverySelected.details,
        setOpen,
        setInfo,
        deliverySelected.productsArr,
        deliverySelected.qtdsArr,
        deliverySelected.seriesArr,
      );
    }
  }, [deliverySelected]);

  let newDados;

  try {
    newDados = JSON.parse(dados);
  } catch {
    return <h2>Não há entregas disponíveis no momento.</h2>;
  }

  const newEntregas = [];
  newDados = newDados.filter((unico) => unico[3] === "N");

  newDados.map((unique) => {
    let productsArray = unique[5].split(";");

    productsArray = productsArray.filter(
      (u, index) => productsArray.indexOf(u) === index,
    );

    newEntregas.push({
      id: unique[0],
      numnota: unique[1],
      data: unique[2],
      details: unique[4],
      products:
        productsArray[0] +
        (productsArray.length > 1
          ? ` e mais ${productsArray.length - 1} produtos`
          : ""),
      productsArr: unique[5],
      qtdsArr: unique[6],
      seriesArr: unique[7],
    });

    return newEntregas;
  });

  return (
    <>
      <Dialog
        open={open}
        maxWidth={false}
        onClose={() => {
          setOpen(false);
          setDeliverySelected(null);
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Detalhes da Entrega</Typography>
          <Button loading onClick={() => setOpen(false)}>
            X
          </Button>
        </DialogTitle>
        <DialogContent sx={{ width: "90vw" }}>{info}</DialogContent>
        <DialogActions>
          <Button loading onClick={() => setOpen(false)}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <MediaQuery orientation="landscape">
        <Desktop
          setOpen={setOpen}
          setInfo={setInfo}
          newEntregas={newEntregas}
        />
      </MediaQuery>

      <MediaQuery orientation="portrait">
        <Mobile
          newEntregas={newEntregas}
          getStatus={getStatus}
          setOpen={setOpen}
          setInfo={setInfo}
        />
      </MediaQuery>
    </>
  );
}

export default Entregas;